

























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import {
  CostListMap,
  MemberMap,
  ProductListMap,
  PaymentTermListMap,
  SetProductPageParams,
  LifeInsuranceBenefitInfos,
  AllProductListMap,
  ProductCfg,
  ProductInfoListMap
} from '@/types/newPersion'
import { PonitXYInside } from '@/types/common/g2Charts'
import {
  pensionInsuranceList,
  pensionInsuranceSave,
  pensionInsuranceSummaryDetail,
  memberList,
} from '@/api/newPersion'
import { BtnList } from '@/types/common/btn'
import { maxNumber } from '@/utils/baseFn'
import { CommonMudule } from '@/store/modules/common'

import FormItem from '@/components/formItem/index.vue'
import NewFooter from '@/views/newPension/components/newFooter'
import SettingDialog from '@/views/newPension/productCard/settingDialog/index.vue'
import TableWrap from '@/views/newPension/productCard/tableWrap/index.vue'
import InsideBarChartWrap from '@/views/newPension/productCard/insideBarChartWrap/index.vue'

import ProductInfoOpt from '@/views/newPension/productCard/productInfoOpt/index.vue'
import ProdutInfoForm from '@/views/newPension/productCard/productInfoForm/index.vue'
import ProductInfoAnalysis from '@/views/newPension/productCard/productInfoAnalysis/index.vue'
import {
  btnSettingList,
} from '@/views/newPension/productCard/utils'
import { cloneDeep } from 'lodash'

@Component({
  components: {
    FormItem,
    NewFooter,
    SettingDialog,
    ProdutInfoForm,
    TableWrap,
    ProductInfoOpt,
    InsideBarChartWrap,
    ProductInfoAnalysis,
  },
})
export default class LifeProductDialog extends Vue {
  @Prop() editParams!: SetProductPageParams | null;
  productCfg = (this.$attrs.proCfg as unknown) as ProductCfg;
  listPage = this.productCfg.listPage;
  editSettings = this.productCfg.editSettings;
  productInfo: ProductListMap | null = null;
  optionsObj: CostListMap | null = null;

  productList: ProductInfoListMap[] = [];
  productMap: ProductInfoListMap | null = null;

  settingDialogShow = false;
  settingProductAnalysisShow = false;
  customerMemberText = '添加保险人';
  memberInfo: MemberMap | null = null;
  btnList = btnSettingList;
  proBtnVal = this.editSettings.annuityProBtnValue || '';
  proBtnList = this.editSettings.annuityProBtnList || '';

  tableData = []

  chartData: PonitXYInside[] = [];
  chartOptions = {
    position: ['0', 0],
    legendPosition: 'top',
    titleNextContent: '岁',
    stackContent: '',
    valueNextContent: '(元)',
    annotationContent: '单位:元',
  };

  paymentTermList: PaymentTermListMap[] = [];
  defaultKey = {
    label: 'name',
    value: 'id',
    key: 'id',
  };

  form: AllProductListMap = cloneDeep(this.editSettings.formObj);
  // form: AllProductListMap = {
  //   customerMember: '',
  //   insuranceId: '',
  //   yearlyAmount: '',
  //   years: '',
  // };

  @Watch('productInfo', { deep: true })
  handleWatchProductInfo (newProductInfo: ProductListMap) {
    const { confirmBtnStatus, confirmBtnIdx } = this.getBtnListDisabledStatus('查看分析')
    const { confirmBtnStatus: confirmBtnStatus1, confirmBtnIdx: confirmBtnIdx1 } = this.getBtnListDisabledStatus('确定')
    if (confirmBtnStatus) {
      if (newProductInfo) {
        this.btnList[confirmBtnIdx].disabled = false
      } else {
        this.btnList[confirmBtnIdx].disabled = true
      }
    }

    if (confirmBtnStatus1) {
      if (newProductInfo) {
        this.btnList[confirmBtnIdx1].disabled = false
      } else {
        this.btnList[confirmBtnIdx1].disabled = true
      }
    }
  }

  created () {
    this.handleLoadType()
  }

  // 获取底部按钮显示隐藏信息
  getBtnListDisabledStatus (btnText: string): {confirmBtnStatus: boolean; confirmBtnIdx: number} {
    const { btnList } = this
    let confirmBtnStatus = false
    let confirmBtnIdx = 0
    for (let i = 0; i < btnList.length; i++) {
      const _btnListItem = btnList[i]
      if (_btnListItem.name.includes(btnText)) {
        confirmBtnStatus = true
        confirmBtnIdx = i
        break
      }
    }

    return {
      confirmBtnStatus,
      confirmBtnIdx
    }
  }

  handleRst () {
    const { insuranceId, yearlyAmount, years } = this.form
    if (insuranceId && yearlyAmount && years) {
      this.handleStatistics()
    } else {
      this.productInfo = null
    }
  }

  handleProList () {
    this.form.insuranceId = ''
    this.form.years = ''
    this.form.yearlyAmount = ''
    this.productInfo = null
    this.getProductList()
  }

  async handleLoadType () {
    const { editParams } = this
    let mid: string | null = null
    await this.getProductList()
    if (editParams) {
      this.customerMemberText = '修改被保险人'
      const { id, name } = editParams
      let _memberList: MemberMap[] | null = null
      const _queryUrlList: Promise<{
        data: AllProductListMap | MemberMap[]
      }>[] = [await memberList({ customerClientId: CommonMudule.customerId })]
      if (id) {
        mid = id
        _queryUrlList.unshift(await pensionInsuranceSummaryDetail({ id }))
        const res = await Promise.all(_queryUrlList)
        if (res[0]?.data && res[1]?.data) {
          const res0 = res[0].data
          _memberList = res[1].data as MemberMap[]
          const _res0 = cloneDeep(res0 as AllProductListMap)
          _res0.years = _res0.years + ''
          delete _res0.insurance
          delete _res0.lifeInsuranceStatistics
          this.form = _res0 as AllProductListMap
          const _find = this?.productList?.find(
            (w: ProductInfoListMap) => w.id === _res0.insuranceId
          )
          if (_find) {
            this.handlePaymentTerm(_find)
          }
        }
      } else {
        const _resMemberList = await memberList({
          customerClientId: CommonMudule.customerId,
        })
        if (_resMemberList?.data) {
          _memberList = _resMemberList.data
        }
      }
      if (_memberList) {
        // 显示个人信息
        const _find = _memberList.find(
          (item: MemberMap) => item.memberName === name
        ) as MemberMap
        this.memberInfo = _find
        this.form.customerMember = _find.memberName
        if (mid) {
          this.handleStatistics()
        }
      }
    }
  }

  async handleStatistics () {
    const _form = {
      age: this.memberInfo?.age,
      gender: this.memberInfo?.gender,
      insuranceId: this.form.insuranceId,
      yearlyAmount: this.form.yearlyAmount,
      years: this.form.years,
    }
    this.form.age = this.memberInfo?.age
    this.form.gender = this.memberInfo?.gender
    this.productInfo = null
    const res = await this.editSettings.countUrlFn(_form)
    if (res?.data) {
      const _data = cloneDeep(res.data)
      this.productInfo = _data
      const chartList: PonitXYInside[] = []
      if (this.productCfg.subType === 'life') {
        // eslint-disable-next-line func-call-spacing
        this.tableData = _data.lifeInsuranceBenefitInfos;
        (cloneDeep(res.data)
          ?.lifeInsuranceBenefitInfos as LifeInsuranceBenefitInfos[]).forEach(
          (w: LifeInsuranceBenefitInfos) => {
            for (const k in this.editSettings.chartEnum) {
              if (k !== 'age') {
                chartList.push({
                  x: w.age + '',
                  y: w[k],
                  type: this.editSettings.chartEnum[k],
                })
              }
            }
          }
        )
      } else {
        // eslint-disable-next-line func-call-spacing
        this.tableData = _data.insuranceInfoList;
        (cloneDeep(res.data)
          ?.insuranceInfoList as LifeInsuranceBenefitInfos[]).forEach(
          (w: LifeInsuranceBenefitInfos) => {
            for (const k in this.editSettings.chartEnum) {
              if (k !== 'age') {
                chartList.push({
                  x: w.age + '',
                  y: w[k],
                  type: this.editSettings.chartEnum[k],
                })
              }
            }
          }
        )
      }

      this.chartOptions.position = [chartList[0].x, maxNumber(chartList, 'y')]
      this.chartData = chartList
    } else {
      this.$message({
        type: 'error',
        message: '当前年龄无法购买此产品',
      })
    }
  }

  private handleChangeProduct (id: string) {
    const _find = this?.productList?.find((w: ProductInfoListMap) => w.id === id)
    if (_find) {
      this.handlePaymentTerm(_find)
      this.form.years = ''
      this.form.yearlyAmount = ''
      this.productInfo = null
      this.form.insuranceId = _find.id
      this.form.insuranceName = _find.name
      this.productMap = _find
    }
  }

  handlePaymentTerm (_find: ProductInfoListMap) {
    const _split = ((_find as unknown) as {
      paymentTerms: string
    }).paymentTerms.split(',')
    const _paymentTermList: PaymentTermListMap[] = []
    for (let i = 0; i < _split.length; i++) {
      const _spi = _split[i]
      _paymentTermList.push({
        id: _spi,
        name: _spi === '1' ? '趸交' : _spi + '年',
      })
    }
    this.paymentTermList = _paymentTermList
  }

  async getProductList () {
    const { productCfg, proBtnVal } = this
    const { insuranceType, lifelongLifeInsurance } = productCfg
    const _form = {
      insuranceType,
      annuityType: proBtnVal,
      lifelongLifeInsurance
    }
    const res = await pensionInsuranceList(_form)
    if (res?.data) {
      this.productList = res.data
    }
  }

  private async handleConfirm () {
    const { memberInfo, productCfg, form } = this
    if (!this.$validator(this.$refs.form)) {
      const _form = {
        customerId: CommonMudule.customerId,
        customerMemberId: memberInfo?.id,
        ...form,
        insuranceType: productCfg.insuranceType
      }
      // if (productCfg.insuranceType === 'Annuity' && this.productCfg.editSettings.insuranceTypeObj) {
      //   _form.insuranceType = this.productCfg.editSettings.insuranceTypeObj[(this.productList.find(item => item.id === this.form.insuranceId)?.annuityType as string)]
      // }
      const res = await pensionInsuranceSave(_form, productCfg.planType)
      if (res?.data) {
        this.$emit('on-click', 'input')
      }
    }
  }

  private handleSettingDialog (status: boolean, tableRow?: MemberMap) {
    if (status) {
      if (tableRow) {
        this.memberInfo = tableRow
        this.form.customerMember = tableRow?.memberName || ''
      }
    }
    this.settingDialogShow = false
  }

  private nextPage (item: BtnList) {
    const { btnType } = item
    switch (btnType) {
      case 'no':
        this.$emit('on-click', 'input')
        break
      case 'cat':
        this.settingProductAnalysisShow = true
        break
      case 'ok':
      default:
        this.handleConfirm()
        break
    }
  }

  private handleFormLableBtn () {
    this.settingDialogShow = true
  }
}
